import styles from './PaymentsComparisonModalHeader.module.scss';

import Grid from '@material-ui/core/Grid';
import cx from 'classnames';
import React from 'react';

import { PaymentOptions } from 'components/PaymentsComparisonLink/PaymentsComparisonModal/PaymentsComparisonModal';
import { TextV2 } from 'components/TextV2/TextV2';

interface IDesktopHeaderProps {
  monthlyOptionHeading: string;
  upfrontOptionHeading: string;
}

const DesktopHeader: React.FC<IDesktopHeaderProps> = ({ monthlyOptionHeading, upfrontOptionHeading }) => (
  <Grid container className={styles.header}>
    <Grid xs={2} className={styles.headerPadding}></Grid>
    <Grid xs={5} className={styles.headerPadding}>
      <TextV2 id={monthlyOptionHeading} value={monthlyOptionHeading} variant="h4-medium" tagName="h4" />
    </Grid>
    <Grid xs={5} className={styles.headerPadding}>
      <TextV2 id={upfrontOptionHeading} value={upfrontOptionHeading} variant="h4-medium" tagName="h4" />
    </Grid>
  </Grid>
);

interface IMobileHeaderProps {
  activePaymentOption: PaymentOptions;
  setActivePaymentOption: (paymentOption: PaymentOptions) => void;
  monthlyOptionHeading: string;
  upfrontOptionHeading: string;
}

const MobileHeader: React.FC<IMobileHeaderProps> = ({
  activePaymentOption,
  setActivePaymentOption,
  monthlyOptionHeading,
  upfrontOptionHeading,
}) => {
  const tabButtonClickHandler = (option: PaymentOptions) => {
    setActivePaymentOption(option);
  };

  return (
    <div className={styles.tabs}>
      <div className={styles.tabsBar}>
        <button
          role="tab"
          className={cx(styles.tabsButton, {
            [styles.tabsButtonActive]: activePaymentOption === PaymentOptions.MONTHLY,
          })}
          onClick={() => tabButtonClickHandler(PaymentOptions.MONTHLY)}
          aria-selected={activePaymentOption === PaymentOptions.MONTHLY}
        >
          <TextV2
            id={monthlyOptionHeading}
            value={monthlyOptionHeading}
            variant="h4-medium"
            tagName="h4"
            className={styles.tabsButtonText}
          />
        </button>
        <button
          role="tab"
          className={cx(styles.tabsButton, {
            [styles.tabsButtonActive]: activePaymentOption === PaymentOptions.UPFRONT,
          })}
          onClick={() => tabButtonClickHandler(PaymentOptions.UPFRONT)}
          aria-selected={activePaymentOption === PaymentOptions.UPFRONT}
        >
          <TextV2
            id={upfrontOptionHeading}
            value={upfrontOptionHeading}
            variant="h4-medium"
            tagName="h4"
            className={styles.tabsButtonText}
          />
        </button>
      </div>
    </div>
  );
};

interface IPaymentComparisonModalHeaderProps {
  activePaymentOption: PaymentOptions;
  setActivePaymentOption: (paymentOption: PaymentOptions) => void;
  monthlyOptionHeading: string;
  upfrontOptionHeading: string;
  isTabs: boolean;
}

export const PaymentsComparisonModalHeader: React.FC<IPaymentComparisonModalHeaderProps> = ({
  monthlyOptionHeading,
  upfrontOptionHeading,
  activePaymentOption,
  setActivePaymentOption,
  isTabs = false,
}) => {
  return isTabs ? (
    <MobileHeader
      activePaymentOption={activePaymentOption}
      setActivePaymentOption={setActivePaymentOption}
      monthlyOptionHeading={monthlyOptionHeading}
      upfrontOptionHeading={upfrontOptionHeading}
    />
  ) : (
    <DesktopHeader monthlyOptionHeading={monthlyOptionHeading} upfrontOptionHeading={upfrontOptionHeading} />
  );
};
